<template>
  <Properties :component="component">
    <template #library-properties>
      <div class="tw-w-full">
        <div class="tw-w-full">
          <Swiper
            :key="'window-property-swiper-' + propertiesGridList.length"
            :modules="swiperModules"
            :pagination="false"
            :slides-per-view="1"
            space-between="100%"
            effect="fade"
            :clickable="true"
            :watch-overflow="true"
            :loop="true"
            :autoplay="{
              delay: 15000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }"
            @slideChange="onSlideChange"
            @swiper="onSwiper"
            class="tw-w-full"
          >
            <SwiperSlide
              v-for="property in propertiesGridList"
              :key="property.property_profile_id"
              class="tw-w-full"
            >
              <section class="n-section-primary !tw-pt-36" style="background-color: var(--white)">
                <div class="tw-w-full">
                  <div v-if="property" class="tw-w-full" style="background-color: var(--white)">
                    <!--
                    <nuxt-link
                      to="/properties"
                      :external="true"
                      class="n-link tw-mb-10 tw-flex tw-items-center tw-gap-6 tw-self-start tw-text-[var(--c-secondary)]"
                    >
                      <svg width="7" height="15" viewBox="0 0 7 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M1.07545 7.91476L4.37536 11.2147L5.2002 10.3898L2.3127 7.50234L5.2002 4.61484L4.37536 3.79001L1.07545 7.08993C0.966087 7.19932 0.904654 7.34766 0.904654 7.50234C0.904654 7.65702 0.966087 7.80537 1.07545 7.91476Z"
                          fill="#F46F2C"
                        />
                      </svg>
                      Back to all properties
                    </nuxt-link>
                    -->
                    <div class="row g-0 lg:tw-flex lg:tw-w-full lg:tw-flex-row-reverse">
                      <div id="w-node-a1202a3f-2ddc-9dfb-6534-95f035b2fc36-89606d9b" class="col-lg-6">
                        <div
                          v-if="getFirstImage(property)"
                          class="image-wrapper image-container tw-overflow-hidden"
                          style="border-radius: var(--rounded)"
                        >
                          <library-image
                            :src="getFirstImage(property)?.background"
                            @click="onClickedImage(getFirstImage(property))"
                            :blur="getImageBlurFilter(property)"
                            :pre-market-blur-text="String(vars.preMarketBlurredImageTextHtml || '')"
                          >
                          </library-image>
                          <div class="first-image-overlay-item">
                            <div v-if="getMedias(property)" style="background-color: var(--white)" class="px-2 py-1">1/{{ getMedias(property).length }}</div>
                          </div>
                        </div>
                        <div class="pt-1 tw-flex tw-w-full tw-flex-nowrap tw-justify-between tw-gap-1 tw-overflow-hidden">
                          <div
                            v-if="getSecondImage(property)"
                            class="col-4 n-cursor-pointer tw-flex-[33%] tw-overflow-hidden"
                            style="border-radius: var(--rounded)"
                          >
                            <library-image
                              :src="getSecondImage(property)?.background"
                              @click="onClickedImage(getSecondImage(property))"
                              :blur="getImageBlurFilter(property)"
                              :pre-market-blur-text="String(vars.preMarketBlurredImageTextHtml || '')"
                              :h-ratio="1"
                              :w-ratio="1.5"
                            >
                            </library-image>
                          </div>
                          <div
                            v-if="getThirdImage(property)"
                            class="col-4 n-cursor-pointer tw-flex-[33%] tw-overflow-hidden"
                            style="border-radius: var(--rounded)"
                          >
                            <library-image
                              :src="getThirdImage(property)?.background"
                              @click="onClickedImage(getThirdImage(property))"
                              :blur="getImageBlurFilter(property)"
                              :pre-market-blur-text="String(vars.preMarketBlurredImageTextHtml || '')"
                              :h-ratio="1"
                              :w-ratio="1.5"
                            >
                            </library-image>
                          </div>
                          <div
                            v-if="getFourthImage(property)"
                            class="col-4 n-cursor-pointer tw-flex-[33%] tw-overflow-hidden"
                            style="border-radius: var(--rounded)"
                          >
                            <library-image
                              :src="getFourthImage(property)?.background"
                              @click="onClickedImage(getFourthImage(property))"
                              :blur="getImageBlurFilter(property)"
                              :pre-market-blur-text="String(vars.preMarketBlurredImageTextHtml || '')"
                              :h-ratio="1"
                              :w-ratio="1.5"
                            >
                            </library-image>
                          </div>
                        </div>
                      </div>
                      <div
                        id="w-node-d0e446c1-f65a-c0b2-1cff-f23737d9485d-89606d9b"
                        class="col-lg-6 ps-lg-5 pt-4 pt-lg-0 lg:!tw-pl-0 lg:tw-pr-5"
                      >
                        <div class="margin-bottom margin-medium">
                          <div class="d-flex flex-row justify-content-between mb-3">
                            <div>
                              <div v-if="property.custom_property_status_title" class="property-image-badge">
                                {{ property.custom_property_status_title }}
                              </div>
                            </div>
                          </div>
                          <h3 class="tw-text-[var(--c-primary)]">
                            {{ property.advert_heading }}
                          </h3>
                          <p>
                            {{ property.display_address }}
                          </p>
                          <div v-if="property.price" class="mt-4">
                            <span class="">
                              {{ property.price.type.name }}
                            </span>
                            <h6>
                              {{ property.price.price }}
                            </h6>
                          </div>
                          <div
                            v-if="!property.is_locked"
                            class="d-flex flex-row justify-content-between mt-5 lg:!tw-justify-start lg:tw-gap-8"
                          >
                            <div v-if="property.bedroom" class="d-flex flex-column">
                              <small>BEDROOM</small>
                              <span>
                                {{ property.bedroom }}
                              </span>
                            </div>
                            <div v-if="property.bathroom" class="d-flex flex-column">
                              <small>BATHROOM</small>
                              <span>
                                {{ property.bathroom }}
                              </span>
                            </div>
                            <div v-if="property.reception" class="d-flex flex-column">
                              <small>RECEPTION</small>
                              <span>
                                {{ property.reception }}
                              </span>
                            </div>
                          </div>
                          <div class="primary-property tw-mt-8 tw-grid tw-grid-cols-8 tw-gap-y-5 xl:tw-gap-x-6 xl:tw-gap-y-0">
                            <div v-if="!property.is_locked" class="tw-col-span-8 xl:tw-col-span-3">
                              <nc-button
                                :class="`tw-w-full !tw-justify-start md:tw-w-auto`"
                                label="BOOK A VIEWING"
                                @on-click="onSendLead(property)"
                              >
                              </nc-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="property" class="tw-w-full !tw-pt-0" style="background-color: var(--white)">
                    <div v-if="!property.is_locked" class="row g-0 tw-w-full tw-gap-12 tw-py-10">
                      <div
                        v-if="property?.featured_video"
                        class="col-lg-6 col-12 d-flex justify-content-end n-cursor-pointer lg:tw-w-[47%]"
                      >
                        <library-iframe :src="property.featured_video.mediaLink" />
                        <div v-if="false" class="image-container">
                          <div class="overlay-item">
                            <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path :d="icons.bigPlayButton" fill="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="property"
                        class="tw-grid tw-grid-cols-12 tw-gap-y-6"
                        :class="property?.featured_video ? 'col-lg-6 col-12 lg:tw-w-[47%]' : 'col-12'"
                      >
                        <div
                          v-for="(feature, key) in property.features"
                          :key="`property-feature-${key}`"
                          class="tw-flex tw-flex-row tw-gap-3"
                          :class="property?.featured_video ? 'tw-col-span-12 lg:tw-col-span-6' : 'tw-col-span-12 lg:tw-col-span-4'"
                        >
                          <div>
                            <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path :d="icons.check" stroke="var(--c-primary)" stroke-width="3" />
                            </svg>
                          </div>
                          <p>
                            {{ feature }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="property.is_locked">
                      <library-login />
                    </div>
                  </div>
                  <div class="tw-w-full tw-flex tw-flex-col tw-gap-y-6 lg:tw-col-span-7 lg:tw-gap-y-10 xl:tw-col-span-8">
                    <property-detail-tabs
                      v-if="property && !property.is_locked"
                      :property="property"
                      :component="component"
                      :marker-color="getMarkerColor()"
                      version="v2"
                    />
                    <property-detail-tabs
                      v-if="property && !property.is_locked"
                      :property="property"
                      :component="component"
                      :marker-color="getMarkerColor()"
                      version="v3"
                    />
                  </div>
                  <div
                    v-if="getSidebarComponents() && getSidebarComponents().length"
                    class="tw-w-full lg:tw-col-span-5 xl:tw-col-span-4"
                  >
                    <div>
                      <available-components-for-sidebar
                        key="property-detail-sidebar"
                        key-prefix="property-detail-sidebar"
                        :specific-components="getSidebarComponents() as any"
                      />
                    </div>
                  </div>
                </div>

                <full-screen-gallery
                  v-if="fullScreenPopupConfig.is_active && activeMedia && getMedias(property) && !property.is_locked"
                  v-model:active-media-index="activeMediaIndex"
                  :component="component"
                  :active-media="activeMedia"
                  :count-of-medias="getMedias(property).length"
                  @close="closeLightbox()"
                />
                <popup v-show="!property.is_locked" :config="sendLeadPopupConfig" custom-width="800px">
                  <template #content>
                    <send-lead
                      v-if="sendLeadPopupConfig.isActive"
                      :property="property"
                      @on-success="onSuccess"
                      @close="sendLeadPopupConfig.isActive = false"
                    />
                  </template>
                </popup>
                <popup v-show="!property.is_locked" :config="successModalConfig" @close="onSuccessModalClosed()">
                  <template #content>
                    <success :text="successPopupText" />
                  </template>
                </popup>
              </section>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </template>
  </Properties>
</template>
<script lang="ts">
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';
import Properties from '~/components/library/Properties.vue';
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';
import { FullScreenPopupMixin } from '~/units/core/mixins/fullScreenPopupMixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';
import PropertyDetail from './PropertyDetail.vue';
import FullScreenGallery from '~/components/common/FullScreenGallery.vue';
import PropertyDetailTabs from '~/components/theme2/properties/PropertyDetailTabs.vue';
import NcButton from '~/components/common/inputs/NcButton.vue';
import Popup from '~/components/common/popup/Popup.vue';
import SendLead from '~/components/common/leads/SendLead.vue';
import Success from '~/components/common/popup/Success.vue';
import { getImagesByCount } from '~/units/properties/store';
import type { Component } from '~/types';
import { usePropertiesStore } from '~/units/properties/stores';
import AvailableComponentsForSidebar from '~/components/theme2/AvailableComponentsForSidebar.vue';
import { type FullScreenModalType, FullScreenModalTypes } from '~/units/core/types';
import { Pagination as SwiperPagination, Autoplay as SwiperAutoplay } from 'swiper/modules';
import { useApplicantsStore } from '~/units/applicants/store';
import { useUsersStore } from '~/units/users/store';
import { PFilterSearchType, PFilterSortOptions } from '~/units/properties/types';
import { BaitStatusesConstants } from '~/units/core/constants/baitStatuses.constants';
import { FetchModes } from '~/units/core/types';
import type { PropertiesFilter, PropertiesQuery, PropertiesFilterRouteQueryKeys } from '~/units/properties/types';
import { useCoreStore } from '~/units/core/store';
import { getVariable } from '~/composables';

export default defineNuxtComponent({
  name: 'WindowProperty',

  mixins: [ComponentMixin, PropertyMixin, FullScreenPopupMixin],

  extends: Properties,

  components: {
    Properties,
    BlockSymbol,
    PropertyDetail,
    Success,
    SendLead,
    Popup,
    NcButton,
    PropertyDetailTabs,
    FullScreenGallery,
    AvailableComponentsForSidebar,
  },

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
      swiper: null as any,
      canPaginateBack: false,
      canPaginateNext: true,
      swiperModules: [SwiperPagination, SwiperAutoplay],
      // Custom property limit for WindowProperty
      customPropertyLimit: 9,
    };
  },

  computed: {
    ...mapState(useWebsiteStore, ['company']),

    fullScreenPopupType(): FullScreenModalType {
      return FullScreenModalTypes.GALLERY;
    },
  },

  async setup({ component }) {
    const route = useRoute();
    const searchType = getVariable(component, 'search_type-text') as PFilterSearchType;

    const applicantsStore = useApplicantsStore();

    const branchId = getVariable(component, 'branch_id-number')
      ? (getVariable(component, 'branch_id-number') as number)
      : undefined;

    await applicantsStore.fetchApplicantBySessionAndType(searchType);

    const applicant = applicantsStore.getApplicantByType(searchType);

    const plainQuery = { ...route.query };
    Object.keys(plainQuery).forEach((key) => {
      if (key.includes('[]') || !key || key.includes('utm')) {
        delete plainQuery[key];
      }
    });

    const isAvailableDefaultValue =
      (getVariable(component, 'is_available_filter_enabled_default-number') as number) === 1;

    const hasCompletedFlag = plainQuery.is_completed === 'true';

    const fetchByQuery = async () => {
      const store = usePropertiesStore();

      store.setInitialLoadConfig({
        is_available: isAvailableDefaultValue,
      });

      const filter: PropertiesFilter = {};
      const query: PropertiesQuery = {
        is_available: isAvailableDefaultValue,
        owner_branch_id: branchId,
      };

      if (hasCompletedFlag) {
        if (searchType === PFilterSearchType.SALES) {
          query.bait_status_id = BaitStatusesConstants.COMPLETED_SALE;
        } else if (searchType === PFilterSearchType.LETTINGS) {
          query.bait_status_id = BaitStatusesConstants.COMPLETED_LET;
        }
      }

      let order: PFilterSortOptions = PFilterSortOptions.SUGGESTED;
      try {
        Object.keys(route.query).forEach((item) => {
          const key = item as PropertiesFilterRouteQueryKeys;
          const value = route.query[key] as string;

          if (value && key !== 'is_completed') {
            if (key === 'is_available') {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-expect-error
              query[key] = value;
            } else if (key === 'sort') {
              order = value as PFilterSortOptions;
            } else if (key !== 'bait_status_id') {
              filter[key] = JSON.parse(value);
            }
          }
        });
      } catch (e) {
        // just to escape errors!
      }

      // Use 20 instead of 9 for WindowProperty
      await store.fetch(FetchModes.INIT, 20, order, searchType, query, filter);
    };

    let isAlreadyRedirected;

    if (Object.keys(plainQuery).length > 0) {
      await fetchByQuery();
      isAlreadyRedirected = true;
    } else if (applicant) {
      const store = usePropertiesStore();

      store.setInitialLoadConfig({
        is_available: isAvailableDefaultValue,
      });

      const filter: PropertiesFilter = {};
      const query: PropertiesQuery = {
        is_available: isAvailableDefaultValue,
        owner_branch_id: branchId,
      };

      const order: PFilterSortOptions = PFilterSortOptions.SUGGESTED;

      const criteria = applicant.criteria;

      const criteriaKeys = [
        'min_bedroom',
        'max_bedroom',
        'min_bathroom',
        'max_bathroom',
        'min_reception',
        'max_reception',
        'min_price',
        'max_price',
        'locations',
        'property_types',
        'new_homes',
        'retirement_homes',
        'shared_ownership',
        'short_let',
        'house_flat_share',
        'pets_allowed',
        'bills_included',
        'must_haves',
        'furnishing',
      ];

      criteriaKeys.forEach((criteriaKey: string) => {
        if (criteria[criteriaKey]) {
          filter[criteriaKey] = criteria[criteriaKey];
        }
      });

      // Use 20 instead of 9 for WindowProperty
      await store.fetch(FetchModes.LOAD_BY_DATA, 20, order, searchType, query, filter);
    } else if (!applicant) {
      await fetchByQuery();
    }

    return {
      isAlreadyRedirected,
      isCompleted: hasCompletedFlag,
    };
  },

  methods: {
    getImageBlurFilter(property: any): string | undefined {
      if (property?.is_locked) {
        return '14px';
      }
      return undefined;
    },

    getSidebarComponents(): Component[] {
      if (this.currentPage && this.currentPage.sidebar) {
        return this.currentPage.sidebar;
      }
      return [];
    },

    getFeaturedImages(property: any) {
      if (property) {
        return getImagesByCount(property, 4);
      }
      return [];
    },

    getFirstImage(property: any) {
      return this.getFeaturedImages(property)[0];
    },

    getSecondImage(property: any) {
      return this.getFeaturedImages(property)[1];
    },

    getThirdImage(property: any) {
      return this.getFeaturedImages(property)[2];
    },

    getFourthImage(property: any) {
      return this.getFeaturedImages(property)[3];
    },

    getMarkerColor() {
      return this.colors.primary;
    },

    getMedias(property: any) {
      return property?.medias;
    },

    onClickedImage(image: any) {
      // Handle image click for lightbox
      this.openJustLightBox(image);
    },

    onSendLead(property: any) {
      // Handle send lead functionality
      this.sendLeadPopupConfig.isActive = true;
    },

    onSuccess() {
      // Handle success callback
      this.successModalConfig.isActive = true;
    },

    onSuccessModalClosed() {
      // Handle success modal closed
      this.successModalConfig.isActive = false;
    },

    onSwiper(swiper: any) {
      this.swiper = swiper;
      this.updatePaginationState();
    },

    onSlideChange() {
      this.updatePaginationState();
    },

    updatePaginationState() {
      if (this.swiper) {
        this.canPaginateBack = !this.swiper.isBeginning;
        this.canPaginateNext = !this.swiper.isEnd;
      }
    },

    // Override fetch methods to use 20 instead of 9
    async onSearch() {
      this.advancedSearchConfig.isActive = false;
      this.isExtendedFilterPopupVisible = false;
      this.isLoading = true;
      const store = usePropertiesStore();

      const query: PropertiesQuery = {
        is_available: this.searchInput.is_available,
        owner_branch_id: this.vars.branchIdNumber,
      };

      this._setQueryBaitStatusForCompleted(query);

      // Use 20 instead of 9 for WindowProperty
      await store.fetch(FetchModes.SEARCH, 20, this.filterCriteria.sort, this.searchType, query, {
        locations: this.mapLocationsForSearch(),
        ...this.filters,
      });
      this.isLoading = false;
      this.computeFilterSummary();
      const coreStore = useCoreStore();
      coreStore.updateMetaTagForce('title', this.filterSummary);
    },

    async loadMore() {
      const store = usePropertiesStore();

      const query: PropertiesQuery = {
        is_available: this.searchInput.is_available,
        owner_branch_id: this.vars.branchIdNumber,
      };

      this._setQueryBaitStatusForCompleted(query);

      // Use 20 instead of 9 for WindowProperty
      await store.fetch(FetchModes.LOAD_MORE, 20, this.filterCriteria.sort, this.searchType, query, {
        locations: this.mapLocationsForSearch(),
        ...this.filters,
      });
    },

    async sort() {
      const store = usePropertiesStore();
      this.isLoading = true;

      const query: PropertiesQuery = {
        is_available: this.searchInput.is_available,
        owner_branch_id: this.vars.branchIdNumber,
      };

      this._setQueryBaitStatusForCompleted(query);

      // Use 20 instead of 9 for WindowProperty
      await store.fetch(FetchModes.SORT, 20, this.filterCriteria.sort, this.searchType, query, {
        locations: this.mapLocationsForSearch(),
        ...this.filters,
      });
      this.isLoading = false;
      this.advancedSearchConfig.isActive = false;
    },

    async onSelectedNewApplicant() {
      const isAvailableDefaultValue =
        (getVariable(this.component, 'is_available_filter_enabled_default-number') as number) === 1;

      const store = usePropertiesStore();
      const applicantsStore = useApplicantsStore();
      const applicant = applicantsStore.applicant;

      store.setInitialLoadConfig({
        is_available: isAvailableDefaultValue,
      });

      const filter: PropertiesFilter = {};
      const query: PropertiesQuery = {
        is_available: isAvailableDefaultValue,
        owner_branch_id: this.vars.branchIdNumber,
      };

      const order: PFilterSortOptions = PFilterSortOptions.SUGGESTED;

      const criteria = applicant.criteria;

      const criteriaKeys = [
        'min_bedroom',
        'max_bedroom',
        'min_bathroom',
        'max_bathroom',
        'min_reception',
        'max_reception',
        'min_price',
        'max_price',
        'locations',
        'property_types',
        'new_homes',
        'retirement_homes',
        'shared_ownership',
        'short_let',
        'house_flat_share',
        'pets_allowed',
        'bills_included',
        'must_haves',
        'furnishing',
      ];

      criteriaKeys.forEach((criteriaKey: string) => {
        filter[criteriaKey] = criteria[criteriaKey];
      });

      // Use 20 instead of 9 for WindowProperty
      await store.fetch(FetchModes.LOAD_BY_DATA, 20, order, this.searchType, query, filter);
      this.applicantProfilesPopupConfig.isActive = false;
      this.onAfterSearch();
    },
  },
});
</script>

<style scoped>
.property-image-badge {
  background-color: var(--dark-brown);
  color: var(--white);
  padding: 10px;
  font-weight: bold;
}

.image-container {
  position: relative;
}

.image-container img {
  display: block;
}

.overlay-item {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.first-image-overlay-item {
  position: absolute;
  bottom: 0.1rem;
  right: 0.1rem;
  transform: translate(-50%, -50%);
  text-align: right;
}

/* Swiper custom styles */
:deep(.swiper-slide) {
  height: auto;
  width: 100% !important;
}


:deep(.swiper) {
  width: 100% !important;
  overflow: visible;
}

:deep(.swiper-wrapper) {
  align-items: stretch;
}


:deep(.swiper-container) {
  width: 100% !important;
}
</style>